class drop_down_gs extends drop_down {

    constructor(select_id, template) {
        super(select_id, template);
        this.select_id = select_id;
        this.fill_select();
    }


    fill_select() {
        var select = this.get_select(), class_list;
        select[0].options.length = 0;
        for (var i = 0; i < gs_data.length; i++) {
            class_list = [];
            select.append('<option data-i="' + i + '" class="' + class_list.join(' ') + '" value="' + gs_data[i].description + '">' + gs_data[i].title + '</option>');
        }
    }

    get_li_data(option_index) {
        var gs = gs_data[option_index];
        var classes = [];

        var huisdia_frontend_looks = gs.huisdia;
        if (huisdia_frontend_looks === '15'){
            huisdia_frontend_looks = 15.6;
        }

        var specs = '<div class="product-spec metric"><span class="spec-label">' + texts.refine_roddia_text + '<span class=\'diameter\'>&nbsp;&#8960;</span>:</span><span class="spec-value">' + gs.stangdia + '&nbsp;mm</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_roddia_text + '<span class=\'diameter\'>&nbsp;&#8960;</span>:</span><span class="spec-value">' + mm_to_inch(gs.stangdia) + '"</span></div>';
        specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_housedia_text + '<span class=\'diameter\'>&nbsp;&#8960;</span>:</span><span class="spec-value">' + huisdia_frontend_looks + '&nbsp;mm</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_housedia_text + '<span class=\'diameter\'>&nbsp;&#8960;</span>:</span><span class="spec-value">' + mm_to_inch(huisdia_frontend_looks) + '"</span></div>';
        specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_stroke_text + '</span><span class="spec-value">' + gs.slag + '&nbsp;mm</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_stroke_text + '</span><span class="spec-value">' + mm_to_inch(gs.slag) + '"</span></div>';
        specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + gs.lengte + '&nbsp;mm</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + mm_to_inch(gs.lengte) + '"</span></div>';
        specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + gs.dschroefdraad + '</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + gs.dschroefdraad + '</span></div>';

        //var price = config_price_ex ? gs.price_ex : gs.price;
        var exchange_rate = price_format['exchangeRate'];
        var tax_rate = price_format['taxRate'];
        if (config_price_ex){
            price = gs.price_ex * exchange_rate;
        } else {
            price = gs.price_ex * exchange_rate * (1 + (tax_rate / 100));
        }

        specs += '<div class="product-spec metric"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';
        specs += '<div class="product-spec imperial"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';

        let cadpic = gs.png;
        let gs_buttons = '';
        if (cadpic) {
            gs_buttons = '<button type="button" class="show_2d_cad_dd" aria-label="2D" data-cadpic="' + cadpic + ',' + this.select_id + '"></button>';
        }

        var price = config_price_ex ? gs.price_ex : gs.price;

        return {
            picture_src: gs.dropdown_img_src,
            title: gs.title,
            price: cf.format_price(price),
            specs: specs,
            sku: texts.refine_sku_text + ' ' + gs.sku,
            stock: this.format_stock(gs, texts),
            id: this.select_id + '_' + option_index,
            classes: classes,
            button2dgs: gs_buttons
        };

    }

    update_visibility() {
        const formData = fd.get();
        const material = document.getElementById('material')?.value ?? '';
        const type = document.getElementById('type')?.value ?? '';
        const wished_force = formData.gasspring_wished_force * 1;
        const filterByCombi = cf.as.sorted_length_combis.length
            && (formData.mp_rod_type !== 'none' || formData.mp_cyl_type !== 'none')
            && (formData.gasspring_wished_force !== "" || formData.gasspring_total_length !== "");
        const allowedCombiGs = filterByCombi
            ? new Set(cf.as.get_unique_gasspring_descriptions(5))
            : null;

        const selectEl = document.getElementById('gasspring');
        if (!selectEl) {
            return;
        }

        this.showing = [];

        for (var i = 0; i < gs_data.length; i++) {
            var show = true;
            var gs = gs_data[i];

            if (gs.aanconfig !== '1') {
                show = false;
            }
            if (gs.materiaal !== material) {
                show = false;
            }
            if (gs.type !== type) {
                show = false;
            }
            if (wished_force) {
                var is_ranked_gs = allowedCombiGs && allowedCombiGs.has(gs.description);
                var skip_force_filter = cf.loading_from_shared_link && is_ranked_gs;

                if (!skip_force_filter && !(wished_force >= (gs.min_force * 1) && wished_force <= (gs.max_force * 1))) {
                    show = false;
                }
            }
            if (allowedCombiGs && !allowedCombiGs.has(gs.description)) {
                show = false;
            }

            const opt = selectEl.options[i];
            if (opt) {
                opt.classList.toggle('hidden', !show);
            }
            if (show) {
                this.showing.push(gs);
            }
        }

        const selectedOption = selectEl.options[selectEl.selectedIndex];
        if (selectedOption && selectedOption.classList.contains('hidden')) {
            if (this.showing.length) {
                $('#gasspring').val(this.showing[0].description).change();
            }
            return;
        }

        if (typeof (this.html_select) !== 'undefined') {
            this.html_select.sync();
        }

    }

}
